// gkc_hash_code : 01EV64EDXCZTX8ZCEMHJHDQ126
import React from 'react';
import * as S from './styled';
import PropTypes from 'prop-types';

const Button = ({
  type,
  children,
  disabled,
  color,
  background,
  gradient,
  radius,
  width,
  height,
  className,
  onClick,
  mr,
  icon,
}) => {
  return (
    <S.ButtonWrapper
      htmlType={type}
      disabled={disabled}
      color={color}
      background={background}
      gradient={gradient}
      radius={radius}
      width={width}
      height={height}
      className={className}
      onClick={onClick}
      onMouseDown={e => e.preventDefault()}
      mr={mr}
      icon={icon}
    >
      {children}
    </S.ButtonWrapper>
  );
};

Button.propTypes = {
  type: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  disabled: PropTypes.bool.isRequired,
  color: PropTypes.string.isRequired,
  background: PropTypes.string.isRequired,
  gradient: PropTypes.string,
  radius: PropTypes.string.isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  mr: PropTypes.number,
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  icon: PropTypes.node,
};

Button.defaultProps = {
  type: 'button',
  children: [''],
  disabled: false,
  color: 'blue',
  background: 'white',
  radius: 'base',
  width: 120,
  height: 36,
  className: '',
  onClick: () => {},
};

export default Button;
